import { Typography } from '@material-tailwind/react'

export const AccessObservations = ({
  showObservations,
  setShowObservations,
  observations,
  setObservations,
  locked = false
}) => {
  const blockIfLocked = (e) => {
    if (!locked) return
    if (e.type === 'keydown' && e.key === 'Tab') return
    e.preventDefault()
    e.stopPropagation()
  }

  return (
    <>
      <div className="flex justify-end">
        {!showObservations && (
          <a
            className={`text-sm hover:underline cursor-pointer ${
              locked ? 'text-gray-300 pointer-events-none' : 'text-blue-500'
            }`}
            onClick={() => !locked && setShowObservations(true)}
            title={locked ? 'Auto-enviar activo: Observaciones bloqueadas' : 'Agregar Observaciones'}
          >
            Agregar Observaciones
          </a>
        )}
      </div>

      {showObservations && (
        <div>
          <Typography variant="small" color="blue-gray" className="mb-1">
            Observaciones
          </Typography>
          <textarea
            id="observations-textarea"
            rows="3"
            value={observations}
            readOnly={locked}
            aria-readonly={locked}
            onChange={(e) => {
              if (locked) return
              setObservations(e.target.value)
            }}
            onKeyDown={blockIfLocked}
            onBeforeInput={blockIfLocked}
            onPaste={blockIfLocked}
            placeholder={
              locked ? 'Auto-enviar activo: Observaciones bloqueadas' : 'Escribe aquí tus observaciones...'
            }
            className={[
              'w-full border rounded px-3 py-2 focus:outline-none resize-none',
              locked ? 'border-gray-200 bg-gray-100 cursor-not-allowed' : 'border-gray-300 focus:ring focus:border-blue-500'
            ].join(' ')}
            title={locked ? 'Auto-enviar activo: Observaciones bloqueadas' : undefined}
          />
        </div>
      )}
    </>
  )
}